class ShopByLook extends HTMLElement {
  slider_instance = null;
  constructor() {
    super();
    this.sliderWrapper = this.querySelector(".shop-by-look__slider .swiper");
    this.nextButton = this.sliderWrapper.querySelector(".swiper-button-next");
    this.prevButton = this.sliderWrapper.querySelector(".swiper-button-prev");
  }

  connectedCallback() {
    if (this.sliderWrapper) {
      this.initializeSliders();
    }
  }

  initializeSliders() {
    this.slider_instance = new Swiper(this.sliderWrapper, {
      slidesPerView: "auto",
      spaceBetween: 24,
      // autoHeight: true,
      // loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        769: {
          //   rewind: true,
          spaceBetween: 16,
        },
      },
    });
  }
}

customElements.define("shop-by-look", ShopByLook);
